const iconWidths = { xs: 42, sm: 42, md: 42, lg: 54, xl: 66 };

const shiftRight = ({ $typeIsCurrency, $hasIcon, $size, $noBorder }) => {
  if ($noBorder) return "2px";
  if ($hasIcon) return `${iconWidths[$size]}px`;
  if ($typeIsCurrency) return `28px`;
  return `16px`;
};

export { shiftRight, iconWidths };
